
<template>
    <div class="content_video_container">
     <img class="back_icon" src="@/assets/img/contentLibrary/back_icon_2.png" @click="handleBack"/>    
     <video class="video_player" controls autoplay>
       <source :src="mediaPath" type="video/mp4">
       </video> 
    </div>
    </template>
    
    <script>
    export default {
        name: 'ContentVideo',
        props: {
            item: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                
            }
        },
        mounted() {
            console.log("Content Video Item:", this.item);
            app.api.Utils.muteAudioManager();
        },
        unmounted() {
            console.log("Content Video Item:", this.item);
            app.api.Utils.unmuteAudioManager();
        },
        methods: {
       handleBack() {
           this.$emit('close-component');
       }
        },
        computed: {
            mediaPath() {
               return app.api.Utils.getMediaPath(this.item.video.src);
            }
        }
    
    };
    </script>
    
    <style lang="scss" scoped>
    .content_video_container {
        width: 100%;
        height: 100%;
    }
    .video_player {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        object-fit: cover;
        height: 100%;
        border-radius: 10px;
    }
   
    .back_icon {
        position: absolute;
        top: -30px;
        left: -1px;
        z-index: 5;
        cursor: pointer;
    }
    </style>